import React, { useEffect, useRef, useState } from "react";
import { STATS } from "../mock/mock";
import { useContent } from "../context/ContentContext";

function useCountUp(target, duration = 2000, start = false) {
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!start) return;
    let raf;
    const t0 = performance.now();
    const tick = (now) => {
      const p = Math.min(1, (now - t0) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      setVal(Math.floor(eased * target));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [start, target, duration]);
  return val;
}

function StatItem({ value, suffix, label, start }) {
  const v = useCountUp(value, 2200, start);
  return (
    <div className="relative flex flex-col items-start py-10">
      <div className="font-serif-display text-[#B87333] text-6xl md:text-7xl lg:text-8xl leading-none">
        {v.toLocaleString("tr-TR")}
        <span className="text-[#D4A574] text-4xl align-top ml-1">{suffix}</span>
      </div>
      <div className="mt-5 pl-4 border-l border-[#B87333]/40">
        <span className="text-[11px] tracking-[0.3em] text-[#f5ede1]/70">RASYONEL • ÇÖZÜM ODAKLI</span>
        <h3 className="mt-2 text-[#f5ede1] font-serif-display text-2xl">{label}</h3>
      </div>
    </div>
  );
}

export default function StatsSection() {
  const { stats = STATS } = useContent();
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => e.isIntersecting && setVisible(true));
    }, { threshold: 0.25 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section ref={ref} className="relative py-24 lg:py-32 bg-[#0a0807] overflow-hidden">
      <div
        className="absolute inset-0 opacity-30 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse 60% 50% at 50% 0%, rgba(184,115,51,0.12), transparent 60%)"
        }}
      />
      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-4">
          <div className="flex items-center gap-3 mb-5">
            <span className="divider-line" />
            <span className="text-[11px] tracking-[0.4em] text-[#B87333]">RAKAMLARLA</span>
          </div>
          <h2 className="font-serif-display text-[#f5ede1] text-4xl lg:text-5xl leading-tight">
            Rasyonel, Çözüm Odaklı Stratejiler
          </h2>
          <p className="mt-6 text-[#a89a85] leading-relaxed">
            Kuruluşumuzdan bu yana binlerce işletmeye teşvik, Ar-Ge ve proje danışmanlığı alanında değer kattık. Rakamlar işimizin hikayesini anlatıyor.
          </p>
        </div>
        <div className="lg:col-span-8 grid grid-cols-1 md:grid-cols-3 gap-px bg-[#B87333]/15">
          {stats.map((s, i) => (
            <div key={i} className="bg-[#0a0807] px-8">
              <StatItem {...s} start={visible} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
